import { render, staticRenderFns } from "./RoomsPricing.vue?vue&type=template&id=2987fe4b&"
import script from "./RoomsPricing.vue?vue&type=script&lang=js&"
export * from "./RoomsPricing.vue?vue&type=script&lang=js&"
import style0 from "./RoomsPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports